import user from "./user"
import screen from "./user/screen.js"
import client from "./client"

export default {
	user,
	screen,
	client
}
